/* carousel-dots.js */
(() => {
  function findTrack(dotsEl) {
    let sibling = dotsEl.previousElementSibling;
    while (sibling) {
      if (sibling.classList.contains('layout-panel-flex--carousel')) return sibling;
      sibling = sibling.previousElementSibling;
    }
    return null;
  }

  function initCarouselDots(dotsEl) {
    if (dotsEl.dataset.initialized === 'true') return;

    const track = findTrack(dotsEl);
    if (!track) return;

    const slides = Array.from(track.children).filter(
      (el) => !(el.childElementCount === 1 && el.firstElementChild.tagName === 'STYLE')
    );
    if (slides.length < 2) return;

    dotsEl.dataset.initialized = 'true';
    dotsEl.innerHTML = '';

    const dots = slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel-dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsEl.appendChild(dot);
      return dot;
    });

    dots[0].classList.add('is-active');

    const ratios = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = slides.indexOf(entry.target);
          if (idx === -1) return;
          ratios.set(idx, entry.isIntersecting ? entry.intersectionRatio : 0);
        });

        let bestIdx = 0;
        let bestRatio = -1;
        ratios.forEach((ratio, idx) => {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestIdx = idx;
          }
        });

        dots.forEach((d, i) => d.classList.toggle('is-active', i === bestIdx));
      },
      { root: track, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
    );

    slides.forEach((slide) => observer.observe(slide));
  }

  function initAll() {
    document.querySelectorAll('[data-carousel-dots]').forEach(initCarouselDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
